<template id="flow-template">
  <div class="homeview-realtime-data">
    <div class="flowCircleOne">
        <div class="circle-chart ">
          <div
            class="task-item"
            v-bind:class="{ item1: index == 1 , item2: index == 0}"
            v-for="(item,index) in realtimeData"
            :key="index"
          >
          <div class="task-icon-wrapper">
            {{item.itemValue}}
              <div class="task-icon"></div>
            </div>
            <div class="task-status">{{item.itemKey}}</div>
            <!-- <div class="task-count">{{item.ItemValue}}</div> -->
          </div>
        </div>
    </div>
      <!-- 设备 table-chart-->
      <div class="table_box" style="margin-top:10px;">
        <el-table :data="tableData" ref="multipleTable" border style="width:96%;margin:0 auto;">
          <el-table-column prop="name" label="设备" width=""></el-table-column>
          <el-table-column prop="total" label="数量" width=""></el-table-column>
          <!-- <el-table-column prop="offLineNum" label="离线" width="60">
            <template slot-scope="scope">
             <span style="color:#fedb4e;">{{scope.row.offLineNum}}</span> 
            </template>
          </el-table-column> -->
          <el-table-column prop="disconnect" label="离线" width="60">
             <template slot-scope="scope">
              <span style="color:#fe4e4e;">{{scope.row.disconnect}}</span> 
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { equipCount } from "../../../../../../request/api";
import dataServerApi from "../../../../../../request/dataServerApi";
import MyApis from "../../../apis";
export default {
  name: "HomeViewFlow",
  componentName: "HomeViewFlow",
  data() {
    return {
      realtimeData: [
        {
          itemKey: "设备总数",
          itemValue: 0,
        },
        {
          itemKey: "离线数",
          itemValue: 0,
        },
      ],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      allNum: 0,
      faultNum: 0,
      allObj: {
        itemKey: "设备总数",
        itemValue: 0,
      },
      faultObj: {
        itemKey: "离线数",
        itemValue: 0,
      },
    };
  },
  created() {},
  mounted() {
    let that = this;
    this.getEquipList();
    this.timer = setInterval(function () {
      that.getEquipList();
    }, 180000);
  },
  methods: {
    getEquipList() {
      this.allObj = this.realtimeData[0];
      this.allObj.itemValue = 0;
      // let allNum=0
      this.faultObj = this.realtimeData[1];
      this.faultObj.itemValue = 0;
      // let faultNum =this.faultObj.itemValue
      let _this = this;
      let resultArr = [];
      let cameraDevice = {
        PageIndex: 1,
        PageSize: 999,
        EquipmentType: "Monitor",
        DeviceId: null,
        DeviceName: "",
        DeviceType: "",
        DeviceTypes: [],
        RegionId: "",
        IsOnline: "",
        ScenicId: null,
      };
      //摄像头设备
      const cameraPromise = new Promise((resolve, reject) => {
        new MyApis.BaseDataApi()
          .GetEquipmentPagingList(cameraDevice)
          .then((r) => {
            // console.log("cameraDevice")
            // console.log(r)

            let data = r.data.Data;

            let total = data.BaseSearch.TotalCount;

            var disconnect = 0;
            let content = data.PageContents;
            content.map((item) => {
              if (item.IsOnline == false) {
                disconnect += 1;
              }
            });
            this.allObj.itemValue += total;
            this.faultObj.itemValue += disconnect;
            let obj = {
              name: "摄像头",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(data);
          })
          .catch((e) => {
            reject(e);
            this.$message({
              type: "error",
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            });
          });
      });

      // 广播设备
      let BroadcastParams = {
        PageIndex: 1,
        PageSize: 999,
        EquipmentType: "Broadcast",
        DeviceId: null,
        DeviceName: null,
        DeviceType: null,
        DeviceTypes: [],
        RegionId: null,
      };
      const BroadcastPromise = new Promise((resolve, reject) => {
        new MyApis.BaseDataApi()
          .GetEquipmentPagingList(BroadcastParams)
          .then((r) => {
            // console.log("BroadcastParams")
            // console.log(r)
            let data = r.data.Data;

            let total = data.BaseSearch.TotalCount;
            var disconnect = 0;
            let content = data.PageContents;
            content.map((item) => {
              if (item.IsOnline == false) {
                disconnect += 1;
              }
            });
            this.allObj.itemValue += total;
            this.faultObj.itemValue += disconnect;
            let obj = {
              name: "广播",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(data);
          })
          .catch((e) => {
            reject(e);
            this.$message({
              type: "error",
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            });
          });
      });
      // WiFi设备
      let wifiParams = {
        PageIndex: 1,
        PageSize: 999,
        Name: "",
        IP: "",
        Status: -1,
        Location: "",
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      const wifiPromise = new Promise((resolve, reject) => {
        new MyApis.WifiApi()
          .GetDeviceListPaging(wifiParams)
          .then((r) => {
            // console.log("BroadcastParams")
            // console.log(r)
            let data = r.data.Data;

            let total = data.BaseSearch.TotalCount;
            var disconnect = 0;
            let content = data.PageContents;
            content.map((item) => {
              if (item.IsOnline == false) {
                disconnect += 1;
              }
            });
            this.allObj.itemValue += total;
            this.faultObj.itemValue += disconnect;
            let obj = {
              name: "WIFI",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(data);
          })
          .catch((e) => {
            reject(e);
            this.$message({
              type: "error",
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
            });
          });
      });
      let ledParams = {
        page: 1,
        size: 999,
        type: "led",
        entityType: "",
        code: "",
        belongUnitCode: "",
        entityTypeCode: "",
        typeOneCode: "led",
        typeTwoCode: "",
        name: "",
        columnName: "id",
        columnSortType: "desc",
      };
      const ledPromise = new Promise((resolve, reject) => {
        dataServerApi.resDeviceFindPage(ledParams).then((res) => {
          //  console.log("led+res")
          //  console.log(res)
          if (res.code == 0) {
            let total = res.count;
            this.allObj.itemValue += total;
            let disconnect = "--";
            let obj = {
              name: "LED",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(res);
          } else {
            reject(res.msg);
          }
        });
      });

      let ticket_gateParams = {
        page: 1,
        size: 100,
        type: "ticket_gate",
        entityType: "",
        code: "",
        belongUnitCode: "",
        entityTypeCode: "",
        typeOneCode: "ticket_gate",
        typeTwoCode: "",
        name: "",
        columnName: "id",
        columnSortType: "desc",
      };
      //闸机数据
      const ticketPromise = new Promise((resolve, reject) => {
        dataServerApi.resDeviceFindPage(ticket_gateParams).then((res) => {
          //  console.log("闸机数据")
          //  console.log(res)
          if (res.code == 0) {
            let total = res.count;
            this.allObj.itemValue += total;
            let disconnect = "--";
            let obj = {
              name: "闸机",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(res);
          } else {
            reject(res.msg);
          }
        });
      });
      let geological_detection = {
        page: 1,
        size: 999,
        type: "geological_detection",
        entityType: "",
        code: "",
        belongUnitCode: "",
        entityTypeCode: "",
        typeOneCode: "geological_detection",
        typeTwoCode: "",
        name: "",
        columnName: "id",
        columnSortType: "desc",
        entityCode: "",
        subarea: "",
        monitorId: null,
      };
      //地质探测
      const geologicalPromise = new Promise((resolve, reject) => {
        dataServerApi.resDeviceFindPage(geological_detection).then((res) => {
          //  console.log("地质探测")
          //  console.log(res)
          if (res.code == 0) {
            let total = res.count;
            this.allObj.itemValue += total;
            let disconnect = "--";
            let obj = {
              name: "地质探测",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(res);
          } else {
            reject(res.msg);
          }
        });
      });
      let environmental_monitor = {
        page: 1,
        size: 999,
        // "type":"environmental_monitor",
        model: "dustNoiseDevice",
        entityType: "",
        code: "",
        belongUnitCode: "",
        entityTypeCode: "",
        typeOneCode: "environmental_monitor",
        typeTwoCode: "",
        name: "",
        columnName: "id",
        columnSortType: "desc",
        entityCode: "",
        subarea: "",
        monitorId: null,
      };
      //环境监测
      const environmentalPromise = new Promise((resolve, reject) => {
        dataServerApi.resDeviceFindPage(environmental_monitor).then((res) => {
          //  console.log("环境监测")
          //  console.log(res)
          if (res.code == 0) {
            let total = res.count;
            this.allObj.itemValue += total;
            let disconnect = "--";
            let obj = {
              name: "环境监测",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(res);
          } else {
            reject(res.msg);
          }
        });
      });
      let sos = {
        page: 1,
        size: 10,
        type: "sos",
        entityType: "",
        code: "",
        belongUnitCode: "",
        entityTypeCode: "",
        typeOneCode: "sos",
        typeTwoCode: "",
        name: "",
        columnName: "id",
        columnSortType: "desc",
        entityCode: "",
        subarea: "",
        monitorId: null,
      };
      //sos
      const sosPromise = new Promise((resolve, reject) => {
        dataServerApi.resDeviceFindPage(sos).then((res) => {
          //  console.log("SOS")
          //  console.log(res)
          if (res.code == 0) {
            let total = res.count;
            this.allObj.itemValue += total;
            let disconnect = "--";
            let obj = {
              name: "SOS",
              total,
              disconnect,
            };
            resultArr.push(obj);
            resolve(res);
          } else {
            reject(res.msg);
          }
        });
      });
      //   let other={"page":1,"size":10,"type":"other","entityType":"","code":"","belongUnitCode":"","entityTypeCode":"","typeOneCode":"other","typeTwoCode":"","name":"","columnName":"id","columnSortType":"desc","entityCode":"","subarea":"","monitorId":null}
      //   //other
      //   const otherPromise =  new Promise((resolve, reject) => {
      //   dataServerApi.resDeviceFindPage(other).then(res=>{
      //     //  console.log("other")
      //     //  console.log(res)
      //      if(res.code==0){
      //       let total = res.count;
      //       this.allObj.itemValue+=total;
      //       let disconnect = "--"
      //       let obj={
      //       name:"其他",
      //       total,
      //       disconnect
      //      }
      //      resultArr.push(obj);
      //      resolve(res)
      //      }else{
      //       reject(res.msg)
      //      }
      //   })
      // })

      Promise.all([
        cameraPromise,
        BroadcastPromise,
        wifiPromise,
        ledPromise,
        ticketPromise,
        geologicalPromise,
        environmentalPromise,
        sosPromise,
      ]).then((values) => {
        console.log(values);
        _this.tableData = resultArr.sort(function (a, b) {
          return b.total - a.total;
        });
      });
    },
  },

  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
</style>